export default __webpack_public_path__ + "static/media/googleImg.3dfa504f.svg";